/* BLED ELEVEN — B26 interactions (vanilla, ~5KB). Redesign Waouh 29-09-2026 */
(function(){
  if(window.__b26)return;window.__b26=true;
  var doc=document,root=doc.documentElement;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf=window.requestAnimationFrame||function(f){return setTimeout(f,16)};

  /* ---------- Header shrink + scroll progress ---------- */
  function initHeader(){
    var header=doc.getElementById('SiteHeader');
    var ticking=false,last=-1,maxH=0;
    window.addEventListener('resize',function(){maxH=0},{passive:true});window.addEventListener('load',function(){maxH=0});
    function update(){
      ticking=false;
      var y=window.pageYOffset||0;
      if((y>24)!==(last>24))root.classList.toggle('b26-scrolled',y>24);
      last=y;
      if(header){
        var now=Date.now();if(!maxH||now-(update.t||0)>1000){update.t=now;maxH=Math.max(1,doc.documentElement.scrollHeight-window.innerHeight)}var max=maxH;
        header.style.setProperty('--b26-progress',Math.min(1,y/max).toFixed(3));
      }
    }
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;raf(update)}},{passive:true});
    update();
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal(scope){
    var els=(scope||doc).querySelectorAll('[data-b26-reveal]:not(.is-in),[data-b26-stagger]:not(.is-in)');
    if(!els.length)return;
    if(reduce||!('IntersectionObserver' in window)){els.forEach(function(el){el.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}});
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(el){io.observe(el)});
  }

  /* ---------- Hero parallax (transform only, in view only) ---------- */
  function initParallax(){
    if(reduce)return;
    var media=doc.querySelector('[data-b26-parallax]');if(!media)return;
    var hero=media.closest('[data-b26-hero]');var visible=true,ticking=false;
    if('IntersectionObserver' in window){new IntersectionObserver(function(e){visible=e[0].isIntersecting}).observe(hero)}
    function update(){ticking=false;if(!visible)return;var y=window.pageYOffset||0;media.style.transform='translate3d(0,'+(y*0.18).toFixed(1)+'px,0)'}
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;raf(update)}},{passive:true});
  }

  /* ---------- Rail progress ---------- */
  function initRails(scope){
    (scope||doc).querySelectorAll('[data-b26-rail]').forEach(function(rail){
      if(rail.dataset.b26Ready)return;rail.dataset.b26Ready='1';
      var bar=rail.parentElement.querySelector('[data-b26-rail-bar]');if(!bar)return;
      function update(){var max=rail.scrollWidth-rail.clientWidth;var vis=rail.clientWidth/Math.max(1,rail.scrollWidth);var p=max>0?rail.scrollLeft/max:1;bar.style.transform='scaleX('+Math.min(1,vis+(1-vis)*p).toFixed(3)+')'}
      rail.addEventListener('scroll',function(){raf(update)},{passive:true});
      window.addEventListener('resize',update,{passive:true});update();
    });
  }

  /* ---------- Cart helpers ---------- */
  function bumpCart(){
    doc.querySelectorAll('.site-header .cart-link').forEach(function(el){el.classList.remove('b26-bump');void el.offsetWidth;el.classList.add('b26-bump')});
  }
  doc.addEventListener('ajaxProduct:added',bumpCart);

  /* ---------- Quick add on B26 cards ---------- */
  function closeSheets(except){
    doc.querySelectorAll('[data-b26-qa-sheet].is-open').forEach(function(s){
      if(s===except)return;s.classList.remove('is-open');s.setAttribute('hidden','');
      var b=s.parentElement.querySelector('[data-b26-qa-open]');if(b)b.setAttribute('aria-expanded','false');
    });
  }
  function addVariant(id,chip,card){
    chip.classList.add('is-busy');chip.disabled=true;
    var routes=(window.theme&&theme.routes)||{};
    fetch(routes.cartAdd||'/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){return r.json().then(function(d){if(!r.ok)throw d;return d})})
      .then(function(data){
        card.classList.add('is-added');closeSheets();
        var product=(data&&data.items&&data.items[0])||data;
        doc.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product:product,addToCartBtn:chip}}));
      })
      .catch(function(err){
        var t=card.querySelector('.b26-card__sheet-title');if(t)t.textContent=(err&&err.description)||'Oups, réessaie.';
      })
      .then(function(){chip.classList.remove('is-busy');chip.disabled=false});
  }
  doc.addEventListener('click',function(e){
    var open=e.target.closest('[data-b26-qa-open]');
    if(open){
      var card=open.closest('[data-b26-card]');var sheet=card&&card.querySelector('[data-b26-qa-sheet]');if(!sheet)return;
      var isOpen=sheet.classList.contains('is-open');closeSheets();
      if(!isOpen){sheet.removeAttribute('hidden');raf(function(){sheet.classList.add('is-open')});open.setAttribute('aria-expanded','true')}
      return;
    }
    var add=e.target.closest('[data-b26-qa-add]');
    if(add){e.preventDefault();addVariant(add.getAttribute('data-b26-qa-add'),add,add.closest('[data-b26-card]'));return}
    if(e.target.closest('[data-b26-qa-close]')){closeSheets();return}
    if(!e.target.closest('[data-b26-qa-sheet]'))closeSheets();
  });

  /* ---------- Tap feedback for touch (adds :active on iOS) ---------- */
  doc.addEventListener('touchstart',function(){},{passive:true});

  /* ---------- PDP: size guide next to the size label ---------- */
  function initPdp(){
    doc.querySelectorAll('.product-single__meta').forEach(function(meta){
      var row=meta.querySelector('.bled-size-guide-row');var sel=meta.querySelector('.b11-size-selector');
      if(row&&sel&&!sel.contains(row))sel.appendChild(row);
    });
  }


  /* =================== PHASE 2 =================== */
  var hoverDevice=window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function norm(t){return String(t||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’'`-]/g,' ').replace(/\s+/g,' ').trim()}

  /* ---------- Split headings per word ---------- */
  function initSplit(scope){
    (scope||doc).querySelectorAll('.b26-h2:not([data-b26-split-done])').forEach(function(h){
      h.setAttribute('data-b26-split-done','');
      if(h.children.length)return;
      var words=h.textContent.trim().split(/\s+/);
      h.setAttribute('aria-label',h.textContent.trim());
      h.innerHTML=words.map(function(w,i){return '<span class="b26-w" aria-hidden="true"><span style="--w:'+i+'">'+w.replace(/</g,'&lt;')+'</span></span>'}).join(' ');
      h.classList.add('b26-split');
      if(!h.closest('[data-b26-reveal],[data-b26-stagger]'))h.setAttribute('data-b26-reveal','');
    });
  }

  /* ---------- Count-up (real numbers already in markup) ---------- */
  function countUp(el){
    var end=parseInt(el.getAttribute('data-b26-count'),10);if(!end||reduce){el.textContent=end||el.textContent;return}
    var t0=null,dur=900;
    function step(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/dur);el.textContent=Math.round(end*(1-Math.pow(1-p,3)));if(p<1)raf(step)}
    el.textContent='0';raf(step);
  }
  function initCounts(scope){
    var els=(scope||doc).querySelectorAll('[data-b26-count]:not([data-b26-counted])');if(!els.length)return;
    if(!('IntersectionObserver' in window)){return}
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.setAttribute('data-b26-counted','');countUp(e.target);io.unobserve(e.target)}})},{threshold:.6});
    els.forEach(function(el){io.observe(el)});
  }

  /* ---------- Image shimmer: mark loaded ---------- */
  function initShimmer(scope){
    (scope||doc).querySelectorAll('.b26-shimmer img').forEach(function(img){
      var box=img.closest('.b26-shimmer');
      function done(){box.classList.add('is-loaded')}
      if(img.complete&&img.naturalWidth)done();else{img.addEventListener('load',done,{once:true});img.addEventListener('error',done,{once:true})}
    });
  }

  /* ---------- Pause infinite CSS loops when offscreen ---------- */
  function initLoops(){
    if(!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(en){en.forEach(function(e){e.target.classList.toggle('is-offscreen',!e.isIntersecting)})});
    doc.querySelectorAll('[data-b26-loop]').forEach(function(el){io.observe(el)});
  }

  /* ---------- Bleds: auto-scrolling swipeable rows + live search ---------- */
  function initBleds(scope){
    (scope||doc).querySelectorAll('[data-b26-bleds]').forEach(function(sec){
      if(sec.dataset.b26Ready)return;sec.dataset.b26Ready='1';
      var rows=[].slice.call(sec.querySelectorAll('[data-b26-marquee]'));
      var visible=false,searching=false;
      rows.forEach(function(row){
        var items=[].slice.call(row.children);
        row._b26={pos:0,paused:false,idle:0,speed:parseFloat(row.getAttribute('data-speed')||'.4'),dir:row.hasAttribute('data-reverse')?-1:1};
        if(reduce||items.length<3)return;
        items.forEach(function(it){var c=it.cloneNode(true);c.setAttribute('aria-hidden','true');c.setAttribute('tabindex','-1');c.classList.add('is-clone');c.removeAttribute('role');row.appendChild(c)});
        function pause(){row._b26.paused=true;clearTimeout(row._b26.idle);row.classList.add('is-user')}
        function resume(){clearTimeout(row._b26.idle);row._b26.idle=setTimeout(function(){row._b26.paused=false;row._b26.pos=row.scrollLeft;row.classList.remove('is-user')},2600)}
        row.addEventListener('touchstart',pause,{passive:true});
        row.addEventListener('touchend',resume,{passive:true});
        row.addEventListener('pointerdown',pause,{passive:true});
        row.addEventListener('pointerup',resume,{passive:true});
        row.addEventListener('wheel',function(){pause();resume()},{passive:true});
        row.addEventListener('mouseenter',pause);row.addEventListener('mouseleave',resume);
        row.addEventListener('focusin',pause);row.addEventListener('focusout',resume);
        if(row._b26.dir<0)raf(function(){row._b26.pos=row.scrollWidth/2;row.scrollLeft=row._b26.pos});
      });
      if(!reduce&&'IntersectionObserver' in window){
        new IntersectionObserver(function(e){visible=e[0].isIntersecting;if(visible)raf(tick)},{rootMargin:'100px 0px'}).observe(sec);
      }
      var last=0;
      function tick(t){
        if(!visible||searching)return;
        var dt=last?Math.min(48,t-last):16;last=t;
        rows.forEach(function(row){
          var st=row._b26;if(!st||st.paused||!row.querySelector('.is-clone'))return;
          var half=st.half||(st.half=row.scrollWidth/2);
          st.pos+=st.speed*st.dir*dt/16;
          if(st.pos>=half)st.pos-=half;if(st.pos<=0)st.pos+=half;
          row.scrollLeft=st.pos;
        });
        raf(tick);
      }
      /* search */
      var q=sec.querySelector('[data-b26-bled-q]'),clear=sec.querySelector('[data-b26-bled-clear]'),status=sec.querySelector('[data-b26-bled-status]'),empty=sec.querySelector('[data-b26-bled-empty]');
      var tiles=[].slice.call(sec.querySelectorAll('[data-b26-bled]:not(.is-clone)'));
      tiles.forEach(function(t){t._k=norm(t.getAttribute('data-b26-bled'))});
      function run(){
        var v=norm(q.value);searching=!!v;sec.classList.toggle('is-searching',searching);clear.hidden=!v;
        var n=0;
        tiles.forEach(function(t){var hit=!v||t._k.indexOf(v)>-1||t._k.split(' ').some(function(w){return w.indexOf(v)===0});t.hidden=!hit;if(hit)n++});
        rows.forEach(function(r){var any=[].some.call(r.children,function(c){return !c.hidden&&!c.classList.contains('is-clone')});r.classList.toggle('is-empty',!any);if(searching)r.scrollLeft=0});
        empty.hidden=!(v&&n===0);
        status.textContent=v?(n?n+' bled'+(n>1?'s':'')+' trouvé'+(n>1?'s':''):''):'';
        if(!v){rows.forEach(function(r){if(r._b26){r._b26.pos=r._b26.dir<0?r.scrollWidth/2:0;r.scrollLeft=r._b26.pos}});last=0;if(visible)raf(tick)}
      }
      if(q){q.addEventListener('input',run);clear.addEventListener('click',function(){q.value='';run();q.focus()})}
    });
  }

  /* ---------- Magnetic buttons (desktop pointer only) ---------- */
  function initMagnetic(){
    if(!hoverDevice||reduce)return;
    doc.addEventListener('pointermove',function(e){
      var b=e.target.closest&&e.target.closest('.b26-btn');if(!b)return;
      var r=b.getBoundingClientRect();var x=(e.clientX-r.left-r.width/2)/r.width,y=(e.clientY-r.top-r.height/2)/r.height;
      b.style.transform='translate3d('+(x*8).toFixed(1)+'px,'+(y*6).toFixed(1)+'px,0)';
    },{passive:true});
    doc.addEventListener('pointerout',function(e){var b=e.target.closest&&e.target.closest('.b26-btn');if(b&&!b.contains(e.relatedTarget))b.style.transform=''},{passive:true});
  }

  /* ---------- Add-to-cart feedback: morph + fly to cart ---------- */
  var lastSourceImg=null;
  doc.addEventListener('click',function(e){
    var t=e.target.closest('[data-b26-qa-add],.product-single__form [data-add-to-cart],[data-b11-pdp-add]');
    if(!t)return;
    var card=t.closest('[data-b26-card]');
    lastSourceImg=card?card.querySelector('.b26-card__img'):doc.querySelector('.product-slideshow .is-selected img, .product-main-slide img');
  },true);
  function flyToCart(img){
    if(reduce||!img||!img.getBoundingClientRect)return;
    var cart=doc.querySelector('.site-header .cart-link');if(!cart)return;
    var a=img.getBoundingClientRect(),b=cart.getBoundingClientRect();if(!a.width)return;
    var f=doc.createElement('img');f.src=img.currentSrc||img.src;f.alt='';f.className='b26-fly';
    var size=Math.min(a.width,a.height,160);
    f.style.cssText='left:'+(a.left+a.width/2-size/2)+'px;top:'+(a.top+a.height/2-size/2)+'px;width:'+size+'px;height:'+size+'px';
    doc.body.appendChild(f);
    var dx=b.left+b.width/2-(a.left+a.width/2),dy=b.top+b.height/2-(a.top+a.height/2);
    if(!f.animate){f.remove();return}
    var anim=f.animate([
      {transform:'translate3d(0,0,0) scale(1)',opacity:1},
      {transform:'translate3d('+dx*0.5+'px,'+(dy*0.5-60)+'px,0) scale(.55)',opacity:1,offset:.55},
      {transform:'translate3d('+dx+'px,'+dy+'px,0) scale(.12)',opacity:.4}
    ],{duration:720,easing:'cubic-bezier(.55,0,.35,1)'});
    anim.onfinish=function(){f.remove();bumpCart()};
  }
  function morph(btn){
    if(!btn||!btn.classList)return;
    btn.classList.add('b26-added');setTimeout(function(){btn.classList.remove('b26-added')},1800);
  }
  doc.addEventListener('ajaxProduct:added',function(e){
    var d=e.detail||{};
    flyToCart(lastSourceImg);lastSourceImg=null;
    var main=doc.querySelector('.product-single__form [data-add-to-cart]');
    morph(d.addToCartBtn&&d.addToCartBtn.matches&&d.addToCartBtn.matches('[data-add-to-cart]')?d.addToCartBtn:main);
    var st=doc.querySelector('[data-b11-pdp-add]');morph(st);
  });

  /* ---------- Cart drawer: lazy wallets, stagger items, pack unlock pulse ---------- */
  function mountWallets(){
    doc.querySelectorAll('[data-b26-wallets]').forEach(function(box){
      var tpl=box.querySelector('template');if(!tpl)return;
      var frag=tpl.content.cloneNode(true);
      frag.querySelectorAll('script').forEach(function(old){var s=doc.createElement('script');[].forEach.call(old.attributes,function(a){s.setAttribute(a.name,a.value)});s.text=old.text;old.parentNode.replaceChild(s,old)});
      tpl.remove();box.appendChild(frag);
    });
  }
  /* B26 speed: express-pay buttons in product cards / quick-buy are kept in <template> and mounted only after the
     visitor interacts AND the card is on screen (each one otherwise spawns a ~165 KB PayPal iframe at load). */
  function mountLazyWallet(box){
    var tpl=box.querySelector(':scope > template');if(!tpl)return;
    var frag=tpl.content.cloneNode(true);
    frag.querySelectorAll('script').forEach(function(old){var s=doc.createElement('script');[].forEach.call(old.attributes,function(a){s.setAttribute(a.name,a.value)});s.text=old.text;old.parentNode.replaceChild(s,old)});
    tpl.remove();box.appendChild(frag);
  }
  function initLazyWallets(){
    var boxes=doc.querySelectorAll('[data-b26-wallets-lazy]');if(!boxes.length)return;
    var started=0,E=['scroll','pointerdown','touchstart','keydown','mousemove'];
    function start(){
      if(started)return;started=1;E.forEach(function(e){removeEventListener(e,start,{passive:true})});
      if(!('IntersectionObserver' in window)){doc.querySelectorAll('[data-b26-wallets-lazy]').forEach(mountLazyWallet);return}
      var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){io.unobserve(x.target);mountLazyWallet(x.target)}})},{rootMargin:'200px 0px'});
      doc.querySelectorAll('[data-b26-wallets-lazy]').forEach(function(b){io.observe(b)});
    }
    E.forEach(function(e){addEventListener(e,start,{passive:true})});
    /* a card focused/hovered before any scroll: mount it right away */
    doc.addEventListener('focusin',function(e){var f=e.target.closest&&e.target.closest('form');var b=f&&f.querySelector('[data-b26-wallets-lazy]');if(b)mountLazyWallet(b)});
  }
  function initDrawer(){
    var drawer=doc.getElementById('CartDrawer');if(!drawer)return;
    var wasOpen=false;
    new MutationObserver(function(){
      var open=drawer.classList.contains('drawer--is-open');
      if(open&&!wasOpen){mountWallets();drawer.classList.remove('b26-stagger');void drawer.offsetWidth;drawer.classList.add('b26-stagger')}
      wasOpen=open;
    }).observe(drawer,{attributes:true,attributeFilter:['class']});
    var offer=drawer.querySelector('[data-bled-cart-offer]');
    if(offer){
      var unlocked=offer.classList.contains('is-unlocked');
      new MutationObserver(function(){
        var u=offer.classList.contains('is-unlocked');
        if(u&&!unlocked)celebrate(offer);
        unlocked=u;
      }).observe(offer,{attributes:true,attributeFilter:['class']});
    }
    /* mount wallets early when idle on cart-heavy pages (product) so express pay is ready */
    if(doc.body.classList.contains('template-cart'))mountWallets();
  }
  function celebrate(el){
    el.classList.remove('b26-pop');void el.offsetWidth;el.classList.add('b26-pop');
    if(reduce)return;
    var box=doc.createElement('span');box.className='b26-confetti';box.setAttribute('aria-hidden','true');
    for(var i=0;i<14;i++){var p=doc.createElement('i');var ang=(i/14)*Math.PI*2;p.style.setProperty('--x',(Math.cos(ang)*(60+Math.random()*50)).toFixed(0)+'px');p.style.setProperty('--y',(Math.sin(ang)*(40+Math.random()*40)-20).toFixed(0)+'px');p.style.setProperty('--r',(Math.random()*360).toFixed(0)+'deg');box.appendChild(p)}
    el.appendChild(box);setTimeout(function(){box.remove()},1300);
  }

  /* ---------- PDP gallery dots ---------- */
  function initGalleryDots(){
    var show=doc.querySelector('.template-product .product-slideshow');if(!show||show.dataset.b26Dots)return;
    var slides=show.querySelectorAll('.product-main-slide');show.dataset.b26Dots='1';
    if(slides.length>1){
      var c=doc.createElement('span');c.className='b26-count';c.setAttribute('aria-hidden','true');show.parentNode.appendChild(c);
      var sync=function(){var idx=0;slides.forEach(function(s,i){if(s.classList.contains('is-selected'))idx=i});c.textContent=(idx+1)+' / '+slides.length};
      new MutationObserver(sync).observe(show,{subtree:true,attributes:true,attributeFilter:['class']});sync();
    }
    /* full-screen viewer with pinch / double-tap zoom */
    var srcs=[].map.call(slides,function(s){var i=s.querySelector('[data-photoswipe-src]');return i?i.getAttribute('data-photoswipe-src'):null});
    if(!srcs.some(Boolean))return;
    var down=null;
    show.addEventListener('pointerdown',function(e){down=[e.clientX,e.clientY,Date.now()]});
    show.addEventListener('click',function(e){
      if(!down||Math.abs(e.clientX-down[0])>8||Math.abs(e.clientY-down[1])>8)return;
      var sl=e.target.closest('.product-main-slide');if(!sl||e.target.closest('button,a,video,model-viewer,iframe'))return;
      var i=[].indexOf.call(slides,sl);if(!srcs[i])return;e.preventDefault();e.stopPropagation();openViewer(srcs,i);
    },true);
  }
  function openViewer(srcs,start){
    var v=doc.createElement('div');v.className='b26-viewer';v.setAttribute('role','dialog');v.setAttribute('aria-label','Photos du produit');
    var list=srcs.map(function(u,k){return u?'<div class="b26-viewer__slide"><img src="'+u+'" alt="" draggable="false"'+(Math.abs(k-start)>1?' loading="lazy"':'')+'></div>':''}).filter(Boolean);
    v.innerHTML='<div class="b26-viewer__track">'+list.join('')+'</div><button type="button" class="b26-viewer__x" aria-label="Fermer">×</button><span class="b26-viewer__n"></span>';
    doc.body.appendChild(v);doc.documentElement.classList.add('b26-viewer-open');
    var track=v.querySelector('.b26-viewer__track'),n=v.querySelector('.b26-viewer__n'),kids=track.children;
    raf(function(){track.scrollLeft=start*track.clientWidth;v.classList.add('is-open')});
    function idx(){return Math.round(track.scrollLeft/Math.max(1,track.clientWidth))}
    function label(){n.textContent=(idx()+1)+' / '+kids.length}label();
    track.addEventListener('scroll',function(){label()},{passive:true});
    function close(){v.classList.remove('is-open');doc.documentElement.classList.remove('b26-viewer-open');setTimeout(function(){v.remove()},250);doc.removeEventListener('keydown',key)}
    function key(e){if(e.key==='Escape')close()}
    doc.addEventListener('keydown',key);
    v.querySelector('.b26-viewer__x').addEventListener('click',close);
    /* zoom state per image */
    var z=1,tx=0,ty=0,img=null,ptr={},pin=null,pan=null,lastTap=0;
    function setT(){if(img)img.style.transform='translate3d('+tx+'px,'+ty+'px,0) scale('+z+')';v.classList.toggle('is-zoomed',z>1.01)}
    function reset(){z=1;tx=ty=0;setT()}
    track.addEventListener('pointerdown',function(e){
      var im=e.target.closest('.b26-viewer__slide');if(!im)return;var el=im.querySelector('img');if(img&&img!==el){reset()}img=el;
      ptr[e.pointerId]=[e.clientX,e.clientY];var ids=Object.keys(ptr);
      if(ids.length===2){var a=ptr[ids[0]],b=ptr[ids[1]];pin={d:Math.hypot(a[0]-b[0],a[1]-b[1]),z:z}}
      else if(z>1.01){pan={x:e.clientX,y:e.clientY,tx:tx,ty:ty}}
      var now=Date.now();if(ids.length===1&&now-lastTap<280){if(z>1.01)reset();else{var r=img.getBoundingClientRect();z=2.5;tx=(r.left+r.width/2-e.clientX)*1.5;ty=(r.top+r.height/2-e.clientY)*1.5;setT()}lastTap=0}else lastTap=now;
    });
    track.addEventListener('pointermove',function(e){
      if(!ptr[e.pointerId])return;ptr[e.pointerId]=[e.clientX,e.clientY];var ids=Object.keys(ptr);
      if(pin&&ids.length>=2){var a=ptr[ids[0]],b=ptr[ids[1]];z=Math.max(1,Math.min(5,pin.z*Math.hypot(a[0]-b[0],a[1]-b[1])/pin.d));if(z<=1.01){tx=ty=0}setT();e.preventDefault()}
      else if(pan&&z>1.01){tx=pan.tx+e.clientX-pan.x;ty=pan.ty+e.clientY-pan.y;setT();e.preventDefault()}
    },{passive:false});
    function up(e){delete ptr[e.pointerId];if(Object.keys(ptr).length<2)pin=null;if(!Object.keys(ptr).length)pan=null}
    track.addEventListener('pointerup',up);track.addEventListener('pointercancel',up);
    /* swipe down to close when not zoomed */
    var sy=null;v.addEventListener('touchstart',function(e){sy=(z<=1.01&&e.touches.length===1)?e.touches[0].clientY:null},{passive:true});
    v.addEventListener('touchend',function(e){if(sy!==null&&e.changedTouches[0].clientY-sy>110)close();sy=null},{passive:true});
  }

  /* ---------- Mobile menu: close on same-page anchors ---------- */
  doc.addEventListener('click',function(e){
    var a=e.target.closest('#NavDrawer a[href*="#"]');if(!a)return;
    var url=new URL(a.href,location.href);
    if(url.pathname===location.pathname){var c=doc.querySelector('#NavDrawer .js-drawer-close');if(c)c.click()}
  });


  /* ---------- Hero carousel: native scroll-snap + autoplay (only when visible, pauses on touch) ---------- */
  function initCarousel(scope){
    [].forEach.call((scope||doc).querySelectorAll('[data-b26-carousel]'),function(track){
      if(track.__b26c)return;track.__b26c=1;
      var hero=track.closest('[data-b26-hero]')||track.parentNode;
      var slides=[].slice.call(track.children);var n=slides.length;if(n<2)return;
      var dotsWrap=hero.querySelector('[data-b26-carousel-dots]');var dots=dotsWrap?[].slice.call(dotsWrap.children):[];
      var ms=+track.getAttribute('data-autoplay')||5000;var idx=0,timer=0,visible=true,held=false,lastLoad=false;
      function set(i){
        if(i===idx&&slides[i].classList.contains('is-active'))return;
        idx=i;
        slides.forEach(function(s,k){s.classList.toggle('is-active',k===i)});
        dots.forEach(function(d,k){d.classList.remove('is-active');d.classList.toggle('is-done',k<i);if(k===i){void d.offsetWidth;d.classList.add('is-active')}});
        var nx=slides[(i+1)%n].querySelector('img[loading="lazy"]');if(nx)nx.loading='eager';
      }
      function go(i){track.scrollTo({left:slides[i].offsetLeft,behavior:reduce?'auto':'smooth'})}
      function stop(){clearTimeout(timer);timer=0}
      function play(){stop();if(!visible||held||doc.hidden)return;timer=setTimeout(function(){go((idx+1)%n)},ms)}
      var st=0;
      track.addEventListener('scroll',function(){
        if(st)return;st=raf(function(){st=0;var i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));i=Math.max(0,Math.min(n-1,i));if(i!==idx){set(i);play()}});
      },{passive:true});
      track.addEventListener('touchstart',function(){held=true;hero.classList.add('is-paused');stop()},{passive:true});
      track.addEventListener('touchend',function(){held=false;hero.classList.remove('is-paused');play()},{passive:true});
      hero.addEventListener('mouseenter',function(){held=true;hero.classList.add('is-paused');stop()});
      hero.addEventListener('mouseleave',function(){held=false;hero.classList.remove('is-paused');play()});
      dots.forEach(function(d,k){d.addEventListener('click',function(){go(k)})});
      doc.addEventListener('visibilitychange',function(){doc.hidden?stop():play()});
      if('IntersectionObserver' in window){new IntersectionObserver(function(es){visible=es[0].isIntersecting;visible?play():stop()},{threshold:.25}).observe(track)}
      if(reduce){hero.classList.add('is-paused');return}
      set(0);play();
    });
  }
  /* B26 speed: non-critical animation work (country marquees: clones + rAF loop) starts after load, when idle */
  function afterLoadIdle(fn){function run(){(window.requestIdleCallback||function(f){setTimeout(f,200)})(function(){fn()},{timeout:2500})}
    if(doc.readyState==='complete')run();else window.addEventListener('load',run,{once:true})}
  window.addEventListener('resize',function(){doc.querySelectorAll('[data-b26-marquee]').forEach(function(r){if(r._b26)r._b26.half=0})},{passive:true});
  function boot(){initHeader();initSplit();initReveal();initParallax();initRails();initPdp();initCounts();initShimmer();initLoops();afterLoadIdle(initBleds);initMagnetic();initDrawer();initLazyWallets();initGalleryDots();initCarousel()}
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',boot);else boot();
  doc.addEventListener('shopify:section:load',function(e){initSplit(e.target);initReveal(e.target);initRails(e.target);initCounts(e.target);initShimmer(e.target);initBleds(e.target);initCarousel(e.target)});
})();
/* B26 drops: scroll-driven type + cover reveal + carousel depth (rAF, in view only) */
(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  function init(sec){
    if(sec.__b26d)return;sec.__b26d=1;
    var type=sec.querySelector('[data-b26-drops-type]'),cover=sec.querySelector('[data-b26-drops-cover]'),rail=sec.querySelector('[data-b26-drops-rail]');
    var cur=sec.querySelector('[data-b26-drops-cur]'),bar=sec.querySelector('[data-b26-drops-bar]');var vis=false,tick=0;
    function frame(){tick=0;if(!vis)return;var r=sec.getBoundingClientRect(),vh=innerHeight,p=Math.min(1,Math.max(0,(vh-r.top)/(vh+r.height)));
      if(type)type.style.setProperty('--dx',(-p*40).toFixed(1)+'vw');
      if(cover){var cr=cover.getBoundingClientRect(),q=Math.min(1,Math.max(0,(vh-cr.top)/(vh*.8)));cover.style.setProperty('--ci',((1-q)*12).toFixed(2)+'%');cover.style.setProperty('--cs',(1.15-q*.15).toFixed(3))}
    }
    function railFrame(){if(!rail)return;var rr=rail.getBoundingClientRect(),mid=rr.left+rr.width/2,best=0,bd=1e9,kids=rail.children;
      for(var i=0;i<kids.length;i++){var b=kids[i].getBoundingClientRect(),c=b.left+b.width/2,d=(c-mid)/rr.width;var ad=Math.abs(d);if(ad<bd){bd=ad;best=i}
        kids[i].style.setProperty('--s',(1-Math.min(ad,1)*.12).toFixed(3));kids[i].style.setProperty('--r',(d*4).toFixed(2)+'deg')}
      if(cur)cur.textContent=('0'+(best+1)).slice(-2);if(bar)bar.style.setProperty('--p',((best+1)/kids.length).toFixed(3));
    }
    function req(){if(!tick)tick=requestAnimationFrame(frame)}
    var rt=0;if(rail){rail.addEventListener('scroll',function(){if(!rt)rt=requestAnimationFrame(function(){rt=0;railFrame()})},{passive:true});railFrame()}
    new IntersectionObserver(function(e){vis=e[0].isIntersecting;if(vis)req()},{rootMargin:'100px 0px'}).observe(sec);
    addEventListener('scroll',req,{passive:true});
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-b26-drops]'),init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
/* B26 menu predictive search (Shopify /search/suggest.json, debounced, cancellable) */
(function(){
  var f=document.querySelector('[data-b26-msearch]');if(!f)return;
  var q=f.querySelector('[data-b26-msearch-q]'),res=f.querySelector('[data-b26-msearch-res]'),t=0,ctl=null,root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function esc(s){return String(s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function money(v){var n=parseFloat(v);return isNaN(n)?'':n.toFixed(2).replace('.',',')+' €'}
  function run(){
    var v=q.value.trim();if(v.length<2){res.innerHTML='';f.classList.remove('has-res');return}
    if(ctl)ctl.abort();ctl=window.AbortController?new AbortController():null;
    fetch(root+'search/suggest.json?q='+encodeURIComponent(v)+'&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last',{signal:ctl&&ctl.signal}).then(function(r){return r.json()}).then(function(d){
      var r=(d.resources&&d.resources.results)||{},p=r.products||[],c=r.collections||[],h='';
      c.slice(0,3).forEach(function(x){h+='<a class="b26-msearch__col" href="'+esc(x.url)+'">'+esc(x.title)+'</a>'});
      if(c.length)h='<div class="b26-msearch__cols">'+h+'</div>';
      p.forEach(function(x,i){h+='<a class="b26-msearch__item" style="--i:'+i+'" href="'+esc(x.url)+'"><img src="'+esc((x.image||x.featured_image&&x.featured_image.url||'')+(x.image&&x.image.indexOf('?')>-1?'&':'?')+'width=120')+'" alt="" width="48" height="60" loading="lazy"><span>'+esc((x.title||'').split(' | ')[0])+'<b>'+money(x.price)+'</b></span></a>'});
      if(!p.length&&!c.length)h='<p class="b26-msearch__none">Aucun résultat pour « '+esc(v)+' ».</p>';
      else h+='<button type="submit" class="b26-msearch__all">Voir tous les résultats</button>';
      res.innerHTML=h;f.classList.add('has-res');
    }).catch(function(){});
  }
  q.addEventListener('input',function(){clearTimeout(t);t=setTimeout(run,220)});
})();


/* story: pinned scroll, 3 steps, country switch */
(function(){
  var s=document.querySelector('[data-b26-story]');if(!s)return;
  var sets=s.querySelectorAll('[data-story-set]'),btns=s.querySelectorAll('[data-story-c]'),bars=s.querySelectorAll('.b26-story__bar b'),inner=s.querySelector('.b26-story__inner'),t=0,vis=false,n=3;
  inner.setAttribute('data-step','0');
  [].forEach.call(btns,function(b){b.addEventListener('click',function(){var c=b.getAttribute('data-story-c');
    [].forEach.call(btns,function(x){var on=x===b;x.classList.toggle('is-on',on);x.setAttribute('aria-selected',on)});
    [].forEach.call(sets,function(x){x.classList.toggle('is-on',x.getAttribute('data-story-set')===c)})})});
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  function f(){t=0;if(!vis)return;var r=s.getBoundingClientRect(),span=s.offsetHeight-innerHeight,p=Math.min(1,Math.max(0,-r.top/span)),x=p*n,st=Math.min(n-1,Math.floor(x)),lp=Math.min(1,(x-st)*2);
    for(var i=0;i<n;i++)bars[i]&&bars[i].style.setProperty('--f',Math.min(1,Math.max(0,x-i)).toFixed(3));
    inner.style.setProperty('--lp',lp.toFixed(3));
    if(inner.getAttribute('data-step')!=String(st))inner.setAttribute('data-step',st)}
  function q(){if(!t)t=requestAnimationFrame(f)}
  new IntersectionObserver(function(e){vis=e[0].isIntersecting;q()}).observe(s);addEventListener('scroll',q,{passive:true});addEventListener('resize',q);
})();
/* express-buy cards: size chips + AJAX add (dynamic checkout handled by Shopify) */
(function(){
  document.addEventListener('click',function(e){var b=e.target.closest('[data-b26-buy] [data-v]');if(!b)return;var f=b.closest('[data-b26-buy]'),id=f.querySelector('[data-b26-buy-id]');id.value=b.getAttribute('data-v');
    [].forEach.call(f.querySelectorAll('[data-v]'),function(x){var on=x===b;x.classList.toggle('is-on',on);x.setAttribute('aria-checked',on)});id.dispatchEvent(new Event('change',{bubbles:true}))});
  document.addEventListener('submit',function(e){var f=e.target.closest&&e.target.closest('[data-b26-buy]');if(!f||!window.fetch)return;e.preventDefault();
    var btn=f.querySelector('.b26-buy__add'),id=f.querySelector('[data-b26-buy-id]'),txt=btn.textContent;btn.classList.add('is-loading');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+id.value,quantity:1}]})})
    .then(function(r){return r.json().then(function(d){if(!r.ok)throw d;return d})})
    .then(function(d){btn.classList.remove('is-loading');btn.classList.add('is-done');btn.textContent='Ajouté ✓';setTimeout(function(){btn.classList.remove('is-done');btn.textContent=txt},1800);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product:(d.items||[])[0]||d,addToCartBtn:btn}}))})
    .catch(function(err){btn.classList.remove('is-loading');btn.textContent=(err&&err.description)||'Oups, réessaie';setTimeout(function(){btn.textContent=txt},2500)})},true);
})();
/* journal: category filter with smooth animation */
(function(){
  var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  [].forEach.call(document.querySelectorAll('[data-b26-mag]'),function(root){
    var chips=root.querySelectorAll('[data-mag-chip]'),pill=root.querySelector('.b26-mag__pill'),list=root.querySelector('[data-mag-list]'),cards=[].slice.call(list.querySelectorAll('.b26-mag__card')),isGrid=root.classList.contains('b26-mag--blog'),busy=0,cur='all';
    // hide chips without articles
    [].forEach.call(chips,function(c){var r=c.getAttribute('data-mag-chip');if(r!=='all'&&!cards.some(function(k){return k.getAttribute('data-rub')===r}))c.hidden=true});
    function movePill(c){if(!pill||!c)return;pill.style.width=c.offsetWidth+'px';pill.style.transform='translateX('+c.offsetLeft+'px)'}
    function feat(){if(!isGrid)return;var first=true;cards.forEach(function(k){k.classList.remove('is-feat');if(!k.hidden&&first){k.classList.add('is-feat');first=false}})}
    function show(r){var i=0;cards.forEach(function(k){var on=r==='all'||k.getAttribute('data-rub')===r;k.hidden=!on;k.classList.remove('is-out','is-in');if(on){k.style.setProperty('--k',i++);if(!rm){void k.offsetWidth;k.classList.add('is-in')}}});feat();if(!isGrid)list.scrollTo({left:0,behavior:'auto'})}
    function go(c,instant){var r=c.getAttribute('data-mag-chip');if(r===cur&&!instant)return;cur=r;
      [].forEach.call(chips,function(x){var on=x===c;x.classList.toggle('is-on',on);x.setAttribute('aria-selected',on)});movePill(c);
      if(isGrid&&history.replaceState)history.replaceState(null,'',r==='all'?location.pathname+location.search:'#'+r);
      if(rm||instant){show(r);return}
      clearTimeout(busy);cards.forEach(function(k){if(!k.hidden)k.classList.add('is-out')});busy=setTimeout(function(){show(r)},260)}
    [].forEach.call(chips,function(c){c.addEventListener('click',function(){go(c)})});
    requestAnimationFrame(function(){movePill(root.querySelector('[data-mag-chip].is-on'))});addEventListener('resize',function(){movePill(root.querySelector('[data-mag-chip].is-on'))});
    feat();
    var h=(location.hash||'').slice(1);if(isGrid&&h){var c=root.querySelector('[data-mag-chip="'+h+'"]');if(c&&!c.hidden)go(c,true)}
  });
  // article reading progress
  var bar=document.querySelector('[data-b26-progress]'),art=document.querySelector('.article__body');
  if(bar&&art){var t=0;function u(){t=0;var r=art.getBoundingClientRect(),total=r.height-innerHeight*.6,p=Math.min(1,Math.max(0,-r.top/Math.max(1,total)));bar.style.transform='scaleX('+p.toFixed(4)+')'}
    addEventListener('scroll',function(){if(!t)t=requestAnimationFrame(u)},{passive:true});u()}
})();
/* blog: ink reveal as cards enter the viewport */
(function(){
  var cards=document.querySelectorAll('.b26-mag .b26-mag__card');if(!cards.length)return;
  if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches){[].forEach.call(cards,function(c){c.classList.add('is-seen')});return}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-seen');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
  [].forEach.call(cards,function(c){io.observe(c)});
})();
/* mega menu: country accordions (one open at a time) */
(function(){
  var root=document.querySelector('[data-b26-mm]');if(!root)return;
  root.addEventListener('click',function(e){var b=e.target.closest('[data-b26-mm-acc]');if(!b)return;
    var acc=document.getElementById(b.getAttribute('aria-controls')),open=b.getAttribute('aria-expanded')!=='true';
    [].forEach.call(root.querySelectorAll('[data-b26-mm-acc][aria-expanded="true"]'),function(x){if(x!==b){x.setAttribute('aria-expanded','false');var a=document.getElementById(x.getAttribute('aria-controls'));a&&a.classList.remove('is-open')}});
    b.setAttribute('aria-expanded',open);acc.classList.toggle('is-open',open);
    if(open)setTimeout(function(){var r=b.getBoundingClientRect();if(r.top<70||r.top>innerHeight*.5)b.scrollIntoView({block:'start',behavior:'smooth'})},120)});
})();
/* Éditions Passeport: country chips + reveal */
(function(){
  [].forEach.call(document.querySelectorAll('[data-b26-pp]'),function(root){
    var chips=root.querySelectorAll('[data-pp-chip]'),panels=root.querySelectorAll('[data-pp-panel]');
    function seen(){root.classList.add('is-seen')}
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){if(es[0].isIntersecting){seen();io.disconnect()}},{rootMargin:'0px 0px -10% 0px'});io.observe(root)}else seen();
    [].forEach.call(chips,function(c){c.addEventListener('click',function(){
      var k=c.getAttribute('data-pp-chip');
      [].forEach.call(chips,function(x){var on=x===c;x.classList.toggle('is-on',on);x.setAttribute('aria-selected',on)});
      [].forEach.call(panels,function(p){var on=p.getAttribute('data-pp-panel')===k;p.hidden=!on;p.classList.toggle('is-on',on);if(on){var g=p.querySelector('.b26-pp__grid');if(g)g.scrollLeft=0}});
      if(c.scrollIntoView&&c.parentNode.scrollWidth>c.parentNode.clientWidth)c.scrollIntoView({inline:'center',block:'nearest',behavior:'smooth'});
    })});
  });
})();
